export default __webpack_public_path__ + "static/media/playroompage-waitplayer.3b90c076.svg";